module.exports = __webpack_public_path__ + "assets/images/coin-$1-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-$1-on.png
// module id = 1497
// module chunks = 1